export enum TravelStatus {
  TRAVEL_STATUS_NONE = 'None',
  TRAVEL_STATUS_BUS = 'Bus',
  TRAVEL_STATUS_OFFERED = 'Offered',
  TRAVEL_STATUS_VALID = 'Valid',
  TRAVEL_STATUS_INVALID = 'Invalid',
  TRAVEL_STATUS_CLAIMED = 'Claimed',
}
export default TravelStatus;
